import React from "react";

const CosmeticRadio = ({ checked }) => (
	<div className={`!size-5 rounded-full mr-2 border-2 flex items-center justify-center ${checked ? "border-black" : "border-gray-400"}`}>
		<div className={`!size-3 rounded-full ${checked ? "bg-black" : "bg-white"}`}></div>
	</div>
);

export default CosmeticRadio;